export default "__VITE_ASSET__oqp2Vy9s__"